module.exports = __webpack_public_path__ + "img/wifi-shopping-mall.9d40d82f.jpg";